import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ConfigurationContext from 'UserRegistration/contexts/ConfigurationContext';
import DataContext from 'UserRegistration/contexts/DataContext';

/**
 * Component that renders the user info in the sidebar of the UserRegistration.
 */
function SidebarUserInfo() {

    const { componentConfig } = useContext(ConfigurationContext);
    const { registrationData } = useContext(DataContext);
    const { t } = useTranslation(componentConfig.i18nNamespaces);

    const personalInfo = registrationData.registrationModel.personalInformation;
    const billingInformation =  registrationData.registrationModel.billingInformation;
    const ccInfo = registrationData.creditCardInfo;
    const sectionNotEmpty = (personalInfo.userFirstName || personalInfo.userLastName || personalInfo.organizationName || personalInfo.emailAddress || ccInfo.type || ccInfo.lastFourDigits || !billingInformation.selectedPayWithNewCard);

    const renderCCLine = () => {

        if (registrationData.metadata.isBillingRequired) {

            if (billingInformation.selectedPayWithNewCard) {
                return <p>{ccInfo.type} {ccInfo.lastFourDigits ? t('endingWith') : ''} {ccInfo.lastFourDigits}</p>;
            } else {
                return <p>{t(`mpg_${billingInformation.existingCCType}`)} {t('endingWith')} {billingInformation.existingCCLastFourDigits}</p>
            }
                
        }

    };

    return (sectionNotEmpty &&
        <div className="user-info-frame">
            <h2 className="user-info-header">{t('userInformation')}</h2>
            <div className="user-info-body">
                <p>{personalInfo.userFirstName} {personalInfo.userLastName}</p>
                <p>{personalInfo.organizationName}</p>
                <p>{personalInfo.phoneNumber}</p>
                {personalInfo.emailAddress && <p>{personalInfo.emailAddress}</p>}
                {personalInfo.emailUsername && <p>{personalInfo.emailUsername}</p>}
                {renderCCLine()}
            </div>
        </div>
    );

}

export default SidebarUserInfo;